/*路由配置*/
import { createRouter, createWebHistory } from 'vue-router';
/*==============================公共端===============================*/
import userLogin from "@/views/public/userLogin.vue";

/*==============================用户端===============================*/
import museumHome from "@/views/home/museumHome.vue";
// 阅读拓展馆
import museumRead from "@/views/home/museumRead.vue";
import readCategory from "@/views/home/read/readCategory.vue";
import readBookPage from '@/views/home/read/readBookPage.vue';
import readBookInfo from '@/views/home/read/readBookInfo.vue';
import readAestheticEdu from '@/views/home/read/readAestheticEdu.vue';
import readBydyw from '@/views/home/read/readBydyw.vue';
import readBydywInfo from '@/views/home/read/readBydywInfo.vue';
import readBookClubCategory from '@/views/home/read/readBookClubCategory.vue';
import readBookClubPage from '@/views/home/read/readBookClubPage.vue';
import readBookClubInfo from '@/views/home/read/readBookClubInfo.vue';
// 非遗文化馆
import museumIntangible from '@/views/home/museumIntangible.vue';
import intangibleOffline from '@/views/home/intangible/intangibleOffline.vue';
import intangibleOfflinePage from '@/views/home/intangible/intangibleOfflinePage.vue';
import intangibleOfflineInfo from '@/views/home/intangible/intangibleOfflineInfo.vue';
// 科学艺术馆
import museumTechnology from '@/views/home/museumTechnology.vue';
import technologyOffline from '@/views/home/technology/technologyOffline.vue';
import technologyOfflinePage from '@/views/home/technology/technologyOfflinePage.vue';
import technologyOfflineInfo from '@/views/home/technology/technologyOfflineInfo.vue';
// 劳动实践馆
import museumLabor from '@/views/home/museumLabor.vue';
import laborOfflinePage from '@/views/home/labor/laborOfflinePage.vue';
import laborOfflineInfo from '@/views/home/labor/laborOfflineInfo.vue';
import laborSeason from '@/views/home/labor/laborSeason.vue';
import laborSeasonPage from '@/views/home/labor/laborSeasonPage.vue';
// 研学体验馆
import museumEducational from '@/views/home/museumEducational.vue';
import educationalOffline from '@/views/home/educational/educationalOffline.vue';
import educationalOfflinePage from '@/views/home/educational/educationalOfflinePage.vue';
import educationalOfflineInfo from '@/views/home/educational/educationalOfflineInfo.vue';

// 博雅美育
import bymyClassify from '@/views/home/bymy/bymyClassify.vue';
import bymyVideos from '@/views/home/bymy/bymyVideos.vue';
import bymyVideoInfo from '@/views/home/bymy/bymyVideoInfo.vue';

// 个人中心
import userCenter from '@/views/home/user/userCenter.vue';

// 教科研-赛事、活动、成果
import eduResearch from '@/views/home/eduResearch/eduResearch.vue';
import eduRaceInfo from '@/views/home/eduResearch/eduRaceInfo.vue';
import eduActivityInfo from '@/views/home/eduResearch/eduActivityInfo.vue';

// 优质资源
import premiumResource from '@/views/home/resource/premiumResource.vue';
import premiumCourseInfo from '@/views/home/resource/premiumCourseInfo.vue';
import premiumCoursewareInfo from '@/views/home/resource/premiumCoursewareInfo.vue';
import premiumCoursewarePlayer from '@/views/home/resource/premiumCoursewarePlayer.vue';

// 名师教研
import teaResearch from '@/views/home/teaResearch/teaResearch.vue';
import teaTeamLessonInfo from '@/views/home/teaResearch/teaTeamLessonInfo.vue';
import teaSelfLessonInfo from '@/views/home/teaResearch/teaSelfLessonInfo.vue';
import teaEvaLessonInfo from '@/views/home/teaResearch/teaEvaLessonInfo.vue';
import teaReleaseLessonInfo from '@/views/home/teaResearch/teaReleaseLessonInfo.vue';

// 营在规划
import excursionPage from '@/views/home/excursion/excursionPage.vue';
import excursionInfo from '@/views/home/excursion/excursionInfo.vue';

/*==============================系统管理端===============================*/
import adminHome from "@/views/admin/AdminHome.vue";
import adminIndex from "@/views/admin/adminIndex.vue";
import overview from "@/views/admin/overview/overview.vue";
// 一级代理商
import supplierLevelOneIndex from "@/views/admin/supplierLevel1/index.vue"
// 二级代理商
import supplierLevelTwoIndex from "@/views/admin/supplierLevel2/index.vue";
// 机构管理
import orgIndex from "@/views/admin/org/index.vue"
// 卡管理
import cardIndex from "@/views/admin/card/index.vue"
// 用户管理
import userIndex from "@/views/admin/user/index.vue"
// 书目管理
import bookIndex from "@/views/admin/book/index.vue"
import bookCreate from "@/views/admin/book/bookCreate.vue";
import bookDetail from "@/views/admin/book/bookDetail.vue";
// 读书会
import eventIndex from "@/views/admin/event/index.vue"
import eventCreate from "@/views/admin/event/eventCreate.vue";
import eventDetail from "@/views/admin/event/eventDetail.vue";
// 主题活动
import museumActivityIndex from "@/views/admin/museumActivity/index.vue"
import museumActivityCreate from "@/views/admin/museumActivity/museumActivityCreate.vue"
import museumActivityDetail from "@/views/admin/museumActivity/museumActivityDetail.vue"
// 教研赛事
import raceIndex from "@/views/admin/race/index.vue"
import raceCreate from "@/views/admin/race/raceCreate.vue"
import raceDetail from "@/views/admin/race/raceDetail.vue"
import raceScale from "@/views/admin/race/raceScale.vue"
import raceManager from "@/views/admin/race/raceManager.vue"

import raceSignInfo from "@/views/admin/race/raceSignInfo.vue"
import csRaceSignInfo from "@/views/admin/race/csRaceSignInfo.vue"
import fsRaceSignInfo from "@/views/admin/race/fsRaceSignInfo.vue"
import zsRaceSignInfo from "@/views/admin/race/zsRaceSignInfo.vue"
// 专题活动
import activityIndex from "@/views/admin/activity/index.vue"
import activityCreate from "@/views/admin/activity/activityCreate.vue"
import activityDetail from "@/views/admin/activity/activityDetail.vue"
import activityManager from "@/views/admin/activity/activityManager.vue"
import activityScale from "@/views/admin/activity/activityScale.vue"

import bmActivitySignInfo from "@/views/admin/activity/bmActivitySignInfo.vue";
import csActivitySignInfo from "@/views/admin/activity/csActivitySignInfo.vue";
import fsActivitySignInfo from "@/views/admin/activity/fsActivitySignInfo.vue";
import zsActivitySignInfo from "@/views/admin/activity/zsActivitySignInfo.vue";
// 个人备课
import selfLesson from "@/views/admin/selfLesson/index.vue"
import selfLessonCreate from '@/views/admin/selfLesson/selfLessonCreate.vue';
import selfLessonDetail from '@/views/admin/selfLesson/selfLessonDetail.vue';
// 协同备课
import teamLessonIndex from "@/views/admin/teamLesson/index.vue"
import teamLessonCreate from '@/views/admin/teamLesson/teamLessonCreate.vue';
import teamLessonDetail from '@/views/admin/teamLesson/teamLessonDetail.vue';
import teamLessonDiscuss from '@/views/admin/teamLesson/teamLessonDiscuss.vue';
// 听评课
import evaLessonIndex from "@/views/admin/evaLesson/index.vue"
import evaLessonCreate from "@/views/admin/evaLesson/evaLessonCreate.vue"
import evaLessonDetail from "@/views/admin/evaLesson/evaLessonDetail.vue"
import evaLessonScale from "@/views/admin/evaLesson/evaLessonScale.vue"
// 系统管理
import museumConfig from '@/views/admin/system/museumConfig.vue';

// 营在规划
import excursionIndex from '@/views/admin/excursion/index.vue';
import excursionCreate from '@/views/admin/excursion/excursionCreate.vue';
import excursionDetail from '@/views/admin/excursion/excursionDetail.vue';

/*==============================一级代理管理端===============================*/
import supplier1CardIndex from '@/views/admin/supplier1Admin/cardIndex.vue';
import supplier1AdminIndex from '@/views/admin/supplier1Admin/supplierIndex.vue';
import supplier1OrgIndex from '@/views/admin/supplier1Admin/orgIndex.vue';

/*==============================二级代理管理端===============================*/
import supplier2CardIndex from '@/views/admin/supplier2Admin/cardIndex.vue';
import supplier2OrgIndex from '@/views/admin/supplier2Admin/orgIndex.vue';

/*==============================机构管理端===============================*/

const routes = [
    /*==============================用户端===============================*/

    { path: '/', redirect: '/museum/home' },
    { path: '/museum/home', name: 'museumHome', meta: { title: '欢迎来到博雅美育浸润·五馆合一' }, component: museumHome },
    { path: '/museum/login', name: 'userLogin', meta: { title: '登录-博雅美育浸润·五馆合一' }, component: userLogin },
    // 阅读拓展馆
    { path: '/museum/read', name: 'museumRead', meta: { title: '阅读拓展馆-博雅美育浸润·五馆合一' }, component: museumRead },
    { path: '/museum/read/category', name: 'readCategory', meta: { title: '名著导读-博雅美育浸润·五馆合一' }, component: readCategory },
    { path: '/museum/read/book', name: 'readBookPage', meta: { title: '推荐书目-博雅美育浸润·五馆合一' }, component: readBookPage },
    { path: '/museum/read/bookInfo', name: 'readBookInfo', meta: { title: '推荐书目-博雅美育浸润·五馆合一' }, component: readBookInfo },
    { path: '/museum/read/aestheticEdu', name: 'readAestheticEdu', meta: { title: '美育浸润-博雅美育浸润·五馆合一' }, component: readAestheticEdu },
    { path: '/museum/read/bydyw', name: 'readBydyw', meta: { title: '博雅大语文-博雅美育浸润·五馆合一' }, component: readBydyw },
    { path: '/museum/read/bydywInfo', name: 'readBydywInfo', meta: { title: '课本详情-博雅美育浸润·五馆合一' }, component: readBydywInfo },
    { path: '/museum/read/bookClub', name: 'readBookClubCategory', meta: { title: '读书会-博雅美育浸润·五馆合一' }, component: readBookClubCategory },
    { path: '/museum/read/clubs', name: 'readBookClubPage', meta: { title: '读书会-博雅美育浸润·五馆合一' }, component: readBookClubPage },
    { path: '/museum/read/bookClubInfo', name: 'readBookClubInfo', meta: { title: '读书会-博雅美育浸润·五馆合一' }, component: readBookClubInfo },
    // 非遗文化管馆
    { path: '/museum/intangible', name: 'museumIntangible', meta: { title: '非遗文化馆-博雅美育浸润·五馆合一' }, component: museumIntangible },
    { path: '/museum/intangible/offline', name: 'intangibleOffline', meta: { title: '非遗工坊-博雅美育浸润·五馆合一' }, component: intangibleOffline },
    { path: '/museum/intangible/offlinePage', name: 'intangibleOfflinePage', meta: { title: '非遗工坊活动-博雅美育浸润·五馆合一' }, component: intangibleOfflinePage },
    { path: '/museum/intangible/offlineInfo', name: 'intangibleOfflineInfo', meta: { title: '非遗工坊详情-博雅美育浸润·五馆合一' }, component: intangibleOfflineInfo },
    
    // 科学艺术馆
    { path: '/museum/technology', name: 'museumTechnology', meta: { title: '科学艺术馆-博雅美育浸润·五馆合一' }, component: museumTechnology },
    { path: '/museum/technology/offline', name: 'technologyOffline', meta: { title: '恒岳科创会-博雅美育浸润·五馆合一' }, component: technologyOffline },
    { path: '/museum/technology/offlinePage', name: 'technologyOfflinePage', meta: { title: '恒岳科创会活动-博雅美育浸润·五馆合一' }, component: technologyOfflinePage },
    { path: '/museum/technology/offlineInfo', name: 'technologyOfflineInfo', meta: { title: '恒岳科创会详情-博雅美育浸润·五馆合一' }, component: technologyOfflineInfo },
    // 劳动实践馆
    { path: '/museum/labor', name: 'museumLabor', meta: { title: '劳动实践馆-博雅美育浸润·五馆合一' }, component: museumLabor },
    { path: '/museum/labor/offlinePage', name: 'laborOfflinePage', meta: { title: '劳动实践馆-博雅美育浸润·五馆合一' }, component: laborOfflinePage },
    { path: '/museum/labor/offlineInfo', name: 'laborOfflineInfo', meta: { title: '劳动实践馆-博雅美育浸润·五馆合一' }, component: laborOfflineInfo },
    { path: '/museum/labor/season', name: 'laborSeason', meta: { title: '四季劳动主题活动-博雅美育浸润·五馆合一' }, component: laborSeason },
    { path: '/museum/labor/seasonPage', name: 'laborSeasonPage', meta: { title: '四季劳动主题活动-博雅美育浸润·五馆合一' }, component: laborSeasonPage },
    // 研学体验馆
    { path: '/museum/educational', name: 'museumEducational', meta: { title: '研学体验馆-博雅美育浸润·五馆合一' }, component: museumEducational },
    { path: '/museum/educational/offline', name: 'educationalOffline', meta: { title: '研学悟心营-博雅美育浸润·五馆合一' }, component: educationalOffline },
    { path: '/museum/educational/offlinePage', name: 'educationalOfflinePage', meta: { title: '研学悟心营活动-博雅美育浸润·五馆合一' }, component: educationalOfflinePage },
    { path: '/museum/educational/offlineInfo', name: 'educationalOfflineInfo', meta: { title: '研学悟心营详情-博雅美育浸润·五馆合一' }, component: educationalOfflineInfo },
    
    // 博雅美育--五馆公用
    { path: '/bymy/theme', name: 'bymyClassify', meta: { title: '博雅美育浸润·五馆合一' }, component: bymyClassify },
    { path: '/bymy/videos', name: 'bymyVideos', meta: { title: '博雅美育浸润·五馆合一' }, component: bymyVideos },
    { path: '/bymy/videoInfo', name: 'bymyVideoInfo', meta: { title: '博雅美育浸润·五馆合一' }, component: bymyVideoInfo },
    
    // 教科研（活动、赛事、成果）
    { path: '/edu/eduResearch', name: 'eduResearch', meta: { title: '赛事活动-博雅美育浸润·五馆合一' }, component: eduResearch },
    { path: '/edu/eduRaceInfo', name: 'eduRaceInfo', meta: { title: '教研赛事详情-博雅美育浸润·五馆合一' }, component: eduRaceInfo },
    { path: '/edu/eduActivityInfo', name: 'eduActivityInfo', meta: { title: '专题活动详情-博雅美育浸润·五馆合一' }, component: eduActivityInfo },
    
    // 优质资源
    { path: '/premium/resource', name: 'premiumResource', meta: { title: '优质资源-博雅美育浸润·五馆合一' }, component: premiumResource },
    { path: '/premium/courseInfo', name: 'premiumCourseInfo', meta: { title: '课程详情-博雅美育浸润·五馆合一' }, component: premiumCourseInfo },
    { path: '/premium/coursewareInfo', name: 'premiumCoursewareInfo', meta: { title: '课件详情-博雅美育浸润·五馆合一' }, component: premiumCoursewareInfo },
    { path: '/premium/coursewarePlayer', name: 'premiumCoursewarePlayer', meta: { title: '课件播放-博雅美育浸润·五馆合一' }, component: premiumCoursewarePlayer },
    
    // 名师教研
    { path: '/tea/teaResearch', name: 'teaResearch', meta: { title: '教研活动-博雅美育浸润·五馆合一' }, component: teaResearch },
    { path: '/tea/teaTeamLessonInfo', name: 'teaTeamLessonInfo', meta: { title: '协同备课详情-博雅美育浸润·五馆合一' }, component: teaTeamLessonInfo },
    { path: '/tea/teaSelfLessonInfo', name: 'teaSelfLessonInfo', meta: { title: '个人备课详情-博雅美育浸润·五馆合一' }, component: teaSelfLessonInfo },
    { path: '/tea/teaEvaLessonInfo', name: 'teaEvaLessonInfo', meta: { title: '听评课详情-博雅美育浸润·五馆合一' }, component: teaEvaLessonInfo },
    { path: '/tea/teaReleaseLessonInfo', name: 'teaReleaseLessonInfo', meta: { title: '已发布备课详情-博雅美育浸润·五馆合一' }, component: teaReleaseLessonInfo },

    // 营在规划
    { path: '/edu/excursion', name: 'excursionPage', meta: { title: '营在规划-博雅美育浸润·五馆合一' }, component: excursionPage },
    { path: '/edu/excursionInfo', name: 'excursionInfo', meta: { title: '研学活动详情-博雅美育浸润·五馆合一' }, component: excursionInfo },

    // 个人中心
    { path: '/museum/userCenter', name: 'userCenter', meta: { title: '个人中心-博雅美育浸润·五馆合一' }, component: userCenter },
    
    //  公用页面
    { path: "/edu/lessonDiscuss", name: "teamLessonDiscuss", meta: { title: '协同备课研讨-博雅美育浸润·五馆合一', hidden: true }, component: teamLessonDiscuss },
            
    /*==============================管理端===============================*/

    {
        path: '/adminHome',
        name: "首页-美育五馆管理中心",
        component: adminHome,
        redirect: "/indexs",
        meta: { title: '首页-美育五馆管理中心' },
        children: [
            {
                path: '/indexs',
                component: adminIndex,
                meta: { title: '首页' },
            },
            { path: "/overview", name: "overview", meta: { title: '管理中心-概览', keepAlive: true }, component: overview },
            { path: "/supplierLevelOne", name: "supplierLevelOne", meta: { title: '管理中心-一级代理', keepAlive: true }, component: supplierLevelOneIndex },
            { path: "/supplierLevelTwo", name: "supplierLevelTwo", meta: { title: '管理中心-二级代理', keepAlive: true }, component: supplierLevelTwoIndex },
            { path: "/org", name: "orgIndex", meta: { title: '管理中心-机构管理', keepAlive: true }, component: orgIndex },
            { path: "/card", name: "cardIndex", meta: { title: '管理中心-卡管理', keepAlive: true }, component: cardIndex },
            { path: "/user", name: "userIndex", meta: { title: '管理中心-用户管理', keepAlive: true }, component: userIndex },
            // 推荐书目
            { path: "/book", name: "bookIndex", meta: { title: '管理中心-书目管理', keepAlive: true }, component: bookIndex },
            { path: "/bookCreate", name: "bookCreate", meta: { title: '管理中心-书目管理', keepAlive: true }, component: bookCreate },
            { path: "/bookDetail", name: "bookDetail", meta: { title: '管理中心-书目详情', keepAlive: true }, component: bookDetail },
            // 读书会
            { path: "/event", name: "eventIndex", meta: { title: '管理中心-读书会', keepAlive: true }, component: eventIndex },
            { path: "/eventCreate", name: "eventCreate", meta: { title: '管理中心-读书会', keepAlive: true }, component: eventCreate },
            { path: "/eventDetail", name: "eventDetail", meta: { title: '管理中心-读书会详情', keepAlive: true }, component: eventDetail },
            // 五馆活动
            { path: "/museumActivity", name: "museumActivityIndex", meta: { title: '管理中心-五馆主题活动', keepAlive: true }, component: museumActivityIndex },
            { path: "/museumActivityCreate", name: "museumActivityCreate", meta: { title: '管理中心-五馆主题活动', keepAlive: true }, component: museumActivityCreate },
            { path: "/museumActivityDetail", name: "museumActivityDetail", meta: { title: '管理中心-五馆主题活动', keepAlive: true }, component: museumActivityDetail },
            // 营在规划
            { path: "/excursion", name: "excursionIndex", meta: { title: '管理中心-营在规划', keepAlive: true }, component: excursionIndex },
            { path: "/excursionCreate", name: "excursionCreate", meta: { title: '管理中心-营在规划', keepAlive: true }, component: excursionCreate },
            { path: "/excursionDetail", name: "excursionDetail", meta: { title: '管理中心-营在规划', keepAlive: true }, component: excursionDetail },
            
            // 教研赛事
            { path: "/race", name: "raceIndex", meta: { title: '管理中心-教研赛事', keepAlive: true }, component: raceIndex },
            { path: "/raceCreate", name: "raceCreate", meta: { title: '管理中心-教研赛事', keepAlive: true }, component: raceCreate },
            { path: "/raceManager", name: "raceManager", meta: { title: '管理中心-教研赛事', keepAlive: true }, component: raceManager },
            { path: "/raceDetail", name: "raceDetail", meta: { title: '管理中心-教研赛事详情', keepAlive: true }, component: raceDetail },
            { path: "/raceScale", name: "raceScale", meta: { title: '管理中心-教研赛事评审量表', keepAlive: true }, component: raceScale },
            
            { path: "/raceSign", name: "raceSignInfo", meta: { title: '教研赛事报名资料', hidden: true }, component: raceSignInfo},
            { path: "/csRaceSign", name: "csRaceSignInfo", meta: { title: '教研赛事报名初审查看', hidden: true }, component: csRaceSignInfo},
            { path: "/fsRaceSign", name: "fsRaceSignInfo", meta: { title: '教研赛事报名复审查看', hidden: true }, component: fsRaceSignInfo},
            { path: "/zsRaceSign", name: "zsRaceSignInfo", meta: { title: '教研赛事报名终审查看', hidden: true }, component: zsRaceSignInfo},
            
            // 专题活动
            { path: "/activity", name: "activityIndex", meta: { title: '管理中心-专题活动', keepAlive: true }, component: activityIndex },
            { path: "/activityCreate", name: "activityCreate", meta: { title: '管理中心-专题活动', keepAlive: true }, component: activityCreate },
            { path: "/activityDetail", name: "activityDetail", meta: { title: '管理中心-专题活动详情', keepAlive: true }, component: activityDetail },
            { path: "/activityManager", name: "activityManager", meta: { title: '管理中心-专题活动', keepAlive: true }, component: activityManager },
            { path: "/activityScale", name: "activityScale", meta: { title: '管理中心-活动评审量表', keepAlive: true }, component: activityScale },
        
            { path: "/activitySign", name: "activitySign", meta: { title: '专题活动-报名资料', hidden: true }, component: bmActivitySignInfo },
            { path: "/csActivitySign", name: "csActivitySign", meta: { title: '专题活动-初审资料', hidden: true }, component: csActivitySignInfo },
            { path: "/fsActivitySign", name: "fsActivitySign", meta: { title: '专题活动-复审资料', hidden: true }, component: fsActivitySignInfo },
            { path: "/zsActivitySign", name: "zsActivitySign", meta: { title: '专题活动-终审资料', hidden: true }, component: zsActivitySignInfo },
            // 个人备课
            { path: "/selfLesson", name: "selfLesson", meta: { title: '个人备课-一体化教研', hidden: true }, component: selfLesson },
            { path: "/selfLessonCreate", name: "selfLessonCreate", meta: { title: '创建个人备课-一体化教研', hidden: true }, component: selfLessonCreate },
            { path: "/selfLessonDetail", name: "selfLessonDetail", meta: { title: '个人备课详情-一体化教研', hidden: true }, component: selfLessonDetail },
            // 协同备课
            { path: "/teamLesson", name: "teamLessonIndex", meta: { title: '协同备课-一体化教研', hidden: true }, component: teamLessonIndex },
            { path: "/teamLessonCreate", name: "teamLessonCreate", meta: { title: '新建协同备课-一体化教研', hidden: true }, component: teamLessonCreate },
            { path: "/teamLessonDetail", name: "teamLessonDetail", meta: { title: '查看协同备课-一体化教研', hidden: true }, component: teamLessonDetail },
            // 听评课
            { path: "/evaLesson", name: "evaLessonIndex", meta: { title: '管理中心-听评课', keepAlive: true }, component: evaLessonIndex },
            { path: "/evaLessonCreate", name: "evaLessonCreate", meta: { title: '管理中心-听评课', keepAlive: true }, component: evaLessonCreate },
            { path: "/evaLessonDetail", name: "evaLessonDetail", meta: { title: '管理中心-听评课详情', keepAlive: true }, component: evaLessonDetail },
            { path: "/evaLessonScale", name: "evaLessonScale", meta: { title: '管理中心-听评课量表', keepAlive: true }, component: evaLessonScale },
            // 一级代理商管理
            { path: "/supplier1Card", name: "supplier1CardIndex", meta: { title: '管理中心-卡管理', keepAlive: true }, component: supplier1CardIndex },
            { path: "/supplier1Level", name: "supplier1AdminIndex", meta: { title: '管理中心-二级代理管理', keepAlive: true }, component: supplier1AdminIndex },
            { path: "/supplier1Org", name: "supplier1OrgIndex", meta: { title: '管理中心-组织机构管理', keepAlive: true }, component: supplier1OrgIndex },
            // 二级代理商管理
            { path: "/supplier2Card", name: "supplier2CardIndex", meta: { title: '管理中心-卡管理', keepAlive: true }, component: supplier2CardIndex },
            { path: "/supplier2Org", name: "supplier2OrgIndex", meta: { title: '管理中心-组织机构管理', keepAlive: true }, component: supplier2OrgIndex },
            // 系统管理
            { path: "/museumConfig", name: "museumConfig", meta: { title: '管理中心-五馆配置', keepAlive: true }, component: museumConfig },
           
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path.includes('/museum/home')||
        to.path === '/museum/login') return next()
    // 获取token
    const tokenStr = window.localStorage.getItem('token')
    if (!tokenStr) return next('/museum/home')
    window.document.title = to.meta.title
    next()
})

export default router
